import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import ReactDOM from 'react-dom';
import Box from '../Box';
import Text from '../Text';
import Content from '../Content';
import { useThemeDefaults } from '../utils';
import { isKbDismiss } from '../utils/kb';
import { focusVisibleStyle, focusOnFocusable } from '../focus';
import { cursor } from '../theme';
import { SlideDown } from '../animations';
import { canUseDOM } from '../utils/environment';
export var FocusableButton = styled('button').withConfig({
  displayName: "MiniOverlay__FocusableButton",
  componentId: "sc-1nskxq-0"
})(focusVisibleStyle, {
  cursor: 'pointer'
});
export var MiniLink = useThemeDefaults(function (props) {
  return {
    as: 'a',
    width: '100%',
    lineHeight: props.theme.topHeader.miniLinksLineHeight,
    textStyle: props.theme.topHeader.miniLinksTextStyle,
    my: '0px',
    cursor: 'pointer',
    color: 'label'
  };
}, styled(Text).withConfig({
  displayName: "MiniOverlay__MiniLink",
  componentId: "sc-1nskxq-1"
})(focusVisibleStyle, cursor));
export var MiniLinkOverlayStyled = useThemeDefaults(function (props) {
  return _objectSpread({
    position: 'fixed',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    bg: 'bg',
    overflow: 'auto'
  }, props);
}, SlideDown);

var MiniLinkOverlay = function MiniLinkOverlay(props) {
  return canUseDOM() ? /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(MiniLinkOverlayStyled, props), document.body) : /*#__PURE__*/React.createElement(MiniLinkOverlayStyled, props);
};

export var MiniOverlay = withTheme( /*#__PURE__*/function (_React$Component) {
  _inherits(_class2, _React$Component);

  var _super = _createSuper(_class2);

  function _class2(props) {
    var _this;

    _classCallCheck(this, _class2);

    _this = _super.call(this, props);

    _this.show = function () {
      _this.setState(function () {
        return {
          visible: true
        };
      });
    };

    _this.hide = function () {
      _this.setState(function () {
        return {
          visible: false
        };
      });
    };

    _this.toggle = function () {
      _this.setState(function (_ref) {
        var visible = _ref.visible;
        return {
          visible: !visible
        };
      });
    };

    _this.state = {
      visible: false
    };
    _this.focusRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(_class2, [{
    key: "focusFirstLink",
    value: function focusFirstLink() {
      if (this.focusRef.current) {
        this.focusRef.current.click(); // safari fix for position:fixed overlays
      }

      focusOnFocusable(this.focusRef.current);
    }
  }, {
    key: "disableBodyScroll",
    value: function disableBodyScroll() {
      this.bodyOverflowStyle = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
  }, {
    key: "enableBodyScroll",
    value: function enableBodyScroll() {
      document.body.style.overflow = this.bodyOverflowStyle;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.visible !== this.state.visible) {
        if (this.state.visible) {
          this.disableBodyScroll();
          this.focusFirstLink();
        } else {
          this.enableBodyScroll();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var overlayStyles = this.props.overlayStyles || {};
      var zIndex = this.props.zIndex || 'unset';
      return /*#__PURE__*/React.createElement(Box, _extends({
        onKeyUp: function onKeyUp(e) {
          if (isKbDismiss(e)) {
            _this2.hide();
          }
        },
        color: "navLabel"
      }, this.props), /*#__PURE__*/React.createElement(FocusableButton, {
        mr: this.props.theme.topHeader.marginX,
        onClick: this.toggle
      }, /*#__PURE__*/React.cloneElement(this.props.controlButton, {
        isOverlayVisible: this.state.visible
      })), /*#__PURE__*/React.createElement(MiniLinkOverlay, _extends({
        zIndex: zIndex,
        visible: this.state.visible
      }, overlayStyles), /*#__PURE__*/React.createElement(Content, {
        ref: this.focusRef
      }, /*#__PURE__*/React.cloneElement(this.props.overlayContent, {
        hideOverlay: this.hide
      }))));
    }
  }]);

  return _class2;
}(React.Component));
process.env.NODE_ENV !== "production" ? MiniOverlay.propTypes = {
  controlButton: PropTypes.element,
  overlayContent: PropTypes.element,
  overlayStyles: PropTypes.object
} : void 0;